// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"src_app_pages_alerts_visualization_alerts-visualization-page_module_ts":"57ac3dcb2068ff19","node_modules_html2canvas_dist_html2canvas_js":"45c09b83827bfad8","node_modules_dompurify_dist_purify_js":"cdf7d655d374f71b","node_modules_canvg_lib_index_es_js":"cccac0283077bac3"}[chunkId] + ".js";
};